import React from 'react'
import {LoggerProps, withLogger} from './withLogger'
import {withPageTitle} from './withPageTitle'
import {withScroller} from './withScroller'
import {withLoadingSpinner} from './withLoadingSpinner'
import EventEmitterExResident from '../pageBaseComponents/EventEmitterExResident'
import {RouterPageProps} from '../RouterPropsInjector'

export type ResidentPagePropsSet =
    LoggerProps &
    RouterPageProps &
    { eventEmitter: EventEmitterExResident }

export const createResidentPage = <OriginalProps extends {}>(
    WrappedComponent: React.ComponentType<OriginalProps & ResidentPagePropsSet>,
) =>
    withLogger(
        WrappedComponent.displayName || 'undefined',
        withScroller(
            withPageTitle(
                withLoadingSpinner(
                    WrappedComponent))),
    )
